import { A9Service, AbstractDataProviderV2, IDataProviderV2 } from 'components/system';
import { RsExportConfig, RsExportConfigInfo, ExportConfigAdd, ExportConfigUpdate } from 'common/customers/services/types';

export type IExportConfigDataProvider = IDataProviderV2<RsExportConfig, RsExportConfigInfo, ExportConfigAdd, ExportConfigUpdate>;

@A9Service('exportConfigDataProvider')
export class ExportConfigDataProvider
    extends AbstractDataProviderV2<RsExportConfig, RsExportConfigInfo, ExportConfigAdd, ExportConfigUpdate>
    implements IExportConfigDataProvider
{
    constructor() {
        super();
        this.setApiUrl('middle://rs/export/config');
    }

    patch(): Promise<null> {
        return Promise.reject('Method is not supported');
    }
}
